import React from 'react';
import { observer } from 'mobx-react-lite';
import { FeaturedBlogPost as RawFeaturedBlogPost } from '../../../components/landingPage/FeaturedBlogPost';
import { Image } from '../Image';
import { SanityObject } from '../../../lib/landingPage';
import { SanityBlogPostPreview } from '../BlogPost/types';

export const FeaturedBlogPost = observer(
    ({
        imageRef,
        title,
        synopsis,
        url,
    }: SanityObject<SanityBlogPostPreview>) => {
        return (
            <RawFeaturedBlogPost
                url={url}
                title={title}
                image={<Image value={{ ...imageRef, dataset: 'blog' }} />}>
                {synopsis}
            </RawFeaturedBlogPost>
        );
    }
);
